/**
 * Thank-you page — post-purchase account creation.
 *
 * POST do `/wp-json/hn/v1/account/create-from-order` z `{order_id, order_key, password}`.
 * Backend (`inc/thankyou-account.php`):
 *  1. Waliduje order_key
 *  2. Tworzy user'a + linkuje order
 *  3. Auto-login przez `wp_set_auth_cookie`
 *  4. Zwraca `{success, redirect}` → ten moduł navigates do My Account.
 *
 * Stany UI:
 *  - idle → click → loading (button disabled + spinner text)
 *  - success → "Konto utworzone! Przekierowuję…" + redirect
 *  - error → message inline (np. "Hasło za krótkie", "Email już zarejestrowany")
 *
 * REST URL: `wpApiSettings.root + 'hn/v1/account/create-from-order'` (default WP REST endpoint).
 * Bez nonce'a — endpoint walidacja idzie przez order_key (open dla guestów).
 */

const REST_PATH = 'hn/v1/account/create-from-order';

function getRestBase() {
    /* `wpApiSettings.root` localized przez wp-includes/js/api-fetch — zawsze dostępny
     * przez WP rest auto-localize. Fallback do `/wp-json/` na wypadek braku. */
    if (window.wpApiSettings && window.wpApiSettings.root) return window.wpApiSettings.root;
    return '/wp-json/';
}

function showMsg(msgEl, text, isError) {
    if (!msgEl) return;
    msgEl.textContent = text;
    msgEl.hidden = false;
    msgEl.classList.toggle('is-error', !!isError);
    msgEl.classList.toggle('is-success', !isError);
}

async function submit(section) {
    const orderId = section.dataset.orderId;
    const orderKey = section.dataset.orderKey;
    const passwordEl = section.querySelector('[data-hn-account-password]');
    const btnEl = section.querySelector('[data-hn-account-submit]');
    const msgEl = section.querySelector('[data-hn-account-msg]');

    if (!passwordEl || !btnEl) return;
    const password = passwordEl.value;

    /* Client-side guard — Backend sprawdza to samo, ale tu zaoszczędzimy HTTP roundtrip. */
    if (!password || password.length < 8) {
        showMsg(msgEl, 'Hasło musi mieć min. 8 znaków.', true);
        passwordEl.focus();
        return;
    }

    const originalLabel = btnEl.textContent;
    btnEl.disabled = true;
    btnEl.textContent = 'Tworzę konto…';
    showMsg(msgEl, '', false);
    msgEl.hidden = true;

    try {
        const res = await fetch(getRestBase() + REST_PATH, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                order_id: parseInt(orderId, 10),
                order_key: orderKey,
                password: password,
            }),
            credentials: 'same-origin',
        });
        const data = await res.json().catch(() => ({}));

        if (!res.ok) {
            const errMsg = (data && data.message) || 'Nie udało się utworzyć konta. Spróbuj jeszcze raz.';
            showMsg(msgEl, errMsg, true);
            btnEl.disabled = false;
            btnEl.textContent = originalLabel;
            return;
        }

        showMsg(msgEl, 'Konto utworzone! Przekierowuję do panelu…', false);
        btnEl.textContent = '✓ Gotowe';
        /* Redirect po 700ms — żeby user zauważył success message przed nawigacją. */
        setTimeout(() => {
            window.location.href = (data && data.redirect) || '/moje-konto/';
        }, 700);
    } catch (err) {
        showMsg(msgEl, 'Błąd połączenia. Spróbuj jeszcze raz.', true);
        btnEl.disabled = false;
        btnEl.textContent = originalLabel;
    }
}

export function initThankyouAccountCreate() {
    const section = document.querySelector('[data-hn-create-account]');
    if (!section) return;
    const btn = section.querySelector('[data-hn-account-submit]');
    if (!btn) return;

    btn.addEventListener('click', () => submit(section));

    /* Enter w polu hasła submit'uje (UX — user naturalnie naciska Enter). */
    const passwordEl = section.querySelector('[data-hn-account-password]');
    if (passwordEl) {
        passwordEl.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                submit(section);
            }
        });
    }
}
